<svg
  version="1.1"
  [style.opacity]="opacity"
  [ngClass]="{ secondary: secondary }"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 155.4 48"
>
  <g *ngIf="type === 'classA'">
    <path
      d="M155.3,26.8l-5.1-21.5c-0.4-1.5-1.7-2.6-3.2-2.6h-16.6V2.1c0-0.9-0.7-1.6-1.6-1.6h-9.3
    c-0.9,0-1.6,0.7-1.6,1.6v0.6h-33V1.2h2.4c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4h-5.6c-0.2,0-0.4,0.2-0.4,0.4
    c0,0.2,0.2,0.4,0.4,0.4h2.4v1.5h-3.6L79,1.1c-0.3-0.3-0.7-0.5-1.2-0.5H67.5c-0.9,0-1.6,0.7-1.6,1.6v0.5H38L36.5,1
    c-0.3-0.3-0.7-0.5-1.2-0.5H24.9c-0.9,0-1.6,0.7-1.6,1.6v0.6H8.8V1.6c0-0.5-0.2-0.9-0.5-1.2C8,0.1,7.5,0,7.1,0L1.4,0.6
    C0.6,0.6,0,1.3,0,2.2V19c0,0.9,0.7,1.6,1.6,1.6h1.3v17.4c0,1.7,1.3,3.1,3,3.3l13.2,1.4c0.1,0,0.2,0,0.3,0l15.5,0l0,0
    c0.6,0,1.1-0.2,1.5-0.7c0.4-0.4,0.6-1,0.6-1.5c0,0,0-0.1,0-0.1c0.1-4,3.5-7.2,7.6-7.1c4-0.1,7.4,3,7.6,7.1v0.2
    c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,0.9,0.6,1.5,0.6h64.5c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.6-1,0.6-1.5v0c0.1-4.1,3.5-7.3,7.6-7.2
    c4.1-0.1,7.5,3.1,7.6,7.2v0c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,0.9,0.6,1.5,0.6h13.8c1.8,0,3.3-1.5,3.3-3.3V27.5
    C155.4,27.3,155.4,27,155.3,26.8z M149.8,12.7c0-0.2,0.1-0.4,0.2-0.5l2.2,9.2h-1.6c-0.4,0-0.8-0.4-0.8-0.8L149.8,12.7z M118.7,2.1
    c0-0.4,0.4-0.8,0.8-0.8h9.3c0.4,0,0.8,0.4,0.8,0.8v0.6h-10.9L118.7,2.1z M66.7,2.2c0-0.4,0.4-0.8,0.8-0.8h10.3
    c0.2,0,0.4,0.1,0.6,0.3l1,1.1H66.7L66.7,2.2z M24.1,2.1c0-0.4,0.4-0.8,0.8-0.8h10.3c0.2,0,0.4,0.1,0.6,0.3l1.1,1.2H24.1L24.1,2.1z
    M16.2,4.5v25.9H6.7V4.5H16.2z M2.9,19.9H1.6c-0.4,0-0.8-0.4-0.8-0.8v-3h2.1L2.9,19.9z M2.9,15.3H0.8V8.8h2.1L2.9,15.3z M5.9,39.6
    c-0.7-0.1-1.2-0.8-1.2-1.5V6c0-0.7,0.5-1.3,1.2-1.5V39.6z M2.9,6v2H0.8V2.2c0-0.4,0.3-0.8,0.7-0.8l5.6-0.6c0.2,0,0.5,0,0.6,0.2
    C7.9,1.2,8,1.4,8,1.6v1.1H6.2C4.4,2.7,2.9,4.2,2.9,6L2.9,6z M20.2,41h-0.8c-0.1,0-0.1,0-0.2,0L6.7,39.7v-8.4h13.5V41z M21,41v-9.7
    h13.7V41L21,41z M17,30.5V4.5h30.7v25.9H17z M53.8,38.5c-1.1-4.1-4.9-7-9.2-6.9c-4.3-0.1-8.1,2.8-9.2,6.9v-7.2h18.3L53.8,38.5z
    M48.5,30.5V4.5H147c0.7,0,1.3,0.5,1.5,1.2l0.2,0.8H72.3v24L48.5,30.5z M69.5,41H54.6v-9.7h14.9L69.5,41z M76.5,41h-6.2v-9.7h6.2
    V41z M92,41H77.3v-9.7H92L92,41z M107,41H92.8v-9.7H107V41z M118.6,41h-10.8v-9.7h10.8V41z M73.1,30.5V7.2h53.1v23.2H73.1z
    M137.8,39.1c-0.9-4.4-4.8-7.6-9.3-7.5c-4.3-0.1-8.1,2.8-9.1,7v-7.3h18.4L137.8,39.1z M147.5,41h-8.9V12.6c0-0.5,0.3-0.8,0.8-0.9
    h7.2c0.5,0,0.8,0.4,0.8,0.9L147.5,41z M153.6,39.4c0,0.8-0.7,1.5-1.5,1.5h-3.8V12.6c0-0.9-0.7-1.6-1.6-1.7h-7.2
    c-0.9,0-1.6,0.8-1.6,1.7v17.8H127V7.2h21.8l1,4.1c-0.5,0.3-0.8,0.8-0.8,1.4v7.9c0,0.9,0.7,1.6,1.6,1.6h1.8l1.2,5c0,0.1,0,0.2,0,0.4
    L153.6,39.4z"
    ></path>
    <path
      d="M28.3,11h-8c-0.9,0-1.6,0.7-1.6,1.6v4.5c0,0.9,0.7,1.6,1.6,1.6h8c0.9,0,1.6-0.7,1.6-1.6v-4.5
    C29.9,11.7,29.2,11,28.3,11z M29.1,17.1c0,0.4-0.3,0.8-0.8,0.8h-8c-0.4,0-0.8-0.3-0.8-0.8v-4.5c0-0.4,0.3-0.8,0.8-0.8h8
    c0.4,0,0.8,0.3,0.8,0.8V17.1z"
    ></path>
    <path
      d="M76.7,17h4.7c0.9,0,1.6-0.7,1.6-1.6v-2.5c0-0.9-0.7-1.6-1.6-1.6h-4.7c-0.9,0-1.6,0.7-1.6,1.6
    v2.5C75.2,16.4,75.9,17,76.7,17z M75.9,12.9c0-0.4,0.3-0.8,0.8-0.8h4.7c0.4,0,0.8,0.3,0.8,0.8v2.5c0,0.4-0.3,0.8-0.8,0.8h-4.7
    c-0.4,0-0.8-0.3-0.8-0.8V12.9z"
    ></path>
    <path
      d="M119.6,12h-10.7c-0.9,0-1.6,0.7-1.6,1.6v4.7c0,0.9,0.7,1.6,1.6,1.6h10.7c0.9,0,1.6-0.7,1.6-1.6
    v-4.7C121.2,12.7,120.5,12,119.6,12z M120.4,18.3c0,0.4-0.3,0.8-0.8,0.8h-10.7c-0.4,0-0.8-0.3-0.8-0.8v-4.7c0-0.4,0.3-0.8,0.8-0.8
    h10.7c0.4,0,0.8,0.3,0.8,0.8V18.3z"
    ></path>
    <path
      d="M136,9.8h-3.5c-0.9,0-1.6,0.7-1.6,1.6v8c0,0.9,0.7,1.6,1.6,1.6h3.5c0.9,0,1.6-0.7,1.6-1.6v-8
    C137.5,10.5,136.8,9.8,136,9.8z M136.8,19.4c0,0.4-0.3,0.8-0.8,0.8h-3.5c-0.4,0-0.8-0.3-0.8-0.8v-8c0-0.4,0.3-0.8,0.8-0.8h3.5
    c0.4,0,0.8,0.3,0.8,0.8V19.4z"
    ></path>
    <path
      d="M44.5,34.5c-3.7,0-6.7,3-6.7,6.7c0,3.7,3,6.7,6.7,6.7c3.7,0,6.7-3,6.7-6.7
    C51.3,37.5,48.3,34.5,44.5,34.5z M44.5,46.2c-2.7,0-5-2.2-5-5c0-2.7,2.2-5,5-5c2.7,0,5,2.2,5,5C49.5,44,47.3,46.2,44.5,46.2z"
    ></path>
    <path
      d="M91.6,25c-0.6,0-1.2,0.5-1.2,1.2v1.6c0,0.6,0.5,1.2,1.2,1.2c0.6,0,1.2-0.5,1.2-1.2v-1.6
    C92.8,25.5,92.3,25,91.6,25z M92,27.7c0,0.2-0.2,0.4-0.4,0.4s-0.4-0.2-0.4-0.4v-1.6c0-0.2,0.2-0.4,0.4-0.4h0c0.2,0,0.4,0.2,0.4,0.4
    l0,0V27.7z"
    ></path>
    <path
      d="M128.4,34.5c-3.7,0-6.7,3-6.7,6.7c0,3.7,3,6.7,6.7,6.7c3.7,0,6.7-3,6.7-6.7
    C135.1,37.5,132.1,34.5,128.4,34.5z M128.4,46.2c-2.7,0-5-2.2-5-5c0-2.7,2.2-5,5-5c2.7,0,5,2.2,5,5C133.3,44,131.1,46.2,128.4,46.2
    z"
    ></path>
    <path
      d="M84.7,18.8h-8.4c-0.9,0-1.6,0.7-1.6,1.6v6.4c0,0.9,0.7,1.6,1.6,1.6h8.4c0.9,0,1.6-0.7,1.6-1.6
    v-6.4C86.2,19.5,85.5,18.8,84.7,18.8z M85.5,26.8c0,0.4-0.3,0.8-0.8,0.8h-8.4c-0.4,0-0.8-0.3-0.8-0.8v-6.4c0-0.4,0.3-0.8,0.8-0.8
    h8.4c0.4,0,0.8,0.3,0.8,0.8V26.8z"
    ></path>
    <path
      d="M145.1,30.5h-3.5c-0.9,0-1.6,0.7-1.6,1.6v2c0,0.9,0.7,1.6,1.6,1.6h3.5c0.9,0,1.6-0.7,1.6-1.6
    v-2C146.6,31.2,145.9,30.5,145.1,30.5z M145.8,34c0,0.4-0.3,0.8-0.8,0.8h-3.5c-0.4,0-0.8-0.3-0.8-0.8v-2c0-0.4,0.3-0.8,0.8-0.8h3.5
    c0.4,0,0.8,0.3,0.8,0.8V34z"
    ></path>
    <path
      d="M145.1,13.2h-3.5c-0.9,0-1.6,0.7-1.6,1.6v6.4c0,0.9,0.7,1.6,1.6,1.6h3.5c0.9,0,1.6-0.7,1.6-1.6
    v-6.4C146.6,13.9,145.9,13.2,145.1,13.2z M145.8,21.2c0,0.4-0.3,0.8-0.8,0.8h-3.5c-0.4,0-0.8-0.3-0.8-0.8v-6.4
    c0-0.4,0.3-0.8,0.8-0.8h3.5c0.4,0,0.8,0.3,0.8,0.8V21.2z"
    ></path>
  </g>
  <g *ngIf="type === 'classB'">
    <path
      d="M109.6,31.5c0.5,0,1-0.3,1.2-0.7c0.3-0.5,0.2-1.2-0.2-1.6l-5.7-6.4c-0.2-0.3-0.5-0.4-0.9-0.5
    l-6.6-1c-0.4-0.1-0.8,0.1-1.1,0.4c-0.3,0.3-0.5,0.7-0.4,1.1l0.5,5.1c0.1,0.6,0.5,1.1,1.1,1.2l11.7,2.3
    C109.4,31.5,109.5,31.5,109.6,31.5z M97.1,27.9l-0.5-5.1c0-0.2,0.1-0.5,0.2-0.6c0.1-0.1,0.3-0.2,0.6-0.2c0,0,0.1,0,0.1,0l6.6,1
    c0.2,0,0.4,0.1,0.5,0.3l5.7,6.4c0.2,0.3,0.3,0.6,0.1,0.9c-0.2,0.3-0.5,0.5-0.8,0.4l-11.7-2.3C97.4,28.6,97.1,28.3,97.1,27.9
    L97.1,27.9z"
    ></path>
    <path
      d="M125,37.2l-0.2-0.6c0-0.1-0.1-0.2-0.1-0.4l-0.2-2c-0.1-1-0.7-1.8-1.6-2.3l-8.7-3.7
    c-0.2-0.1-0.3-0.2-0.4-0.3l-7.3-7.8c-0.4-0.4-0.8-0.7-1.4-0.8l-9.4-4.6c-0.3-0.2-0.6-0.3-1-0.4v-0.5c0-0.7-0.5-1.2-1.2-1.2H67.2
    l-2.5-1.2c-0.2-0.1-0.3-0.1-0.5-0.1h-7.5c-0.7,0-1.2,0.5-1.2,1.2v0.1h-9.7c-0.7,0-1.2,0.5-1.2,1.2v0.3h-7.5c-1.5,0-2.8,1.2-2.9,2.7
    l-1.3,15.8h-0.5c-1.2,0-2.1,0.9-2.1,2.1v5c0,1.1,0.9,2.1,2.1,2.1c0.3,1.2,1.3,2,2.5,2.1l10,0.3l5.7,0h0c0.4,0,0.8-0.2,1.1-0.4
    c0.3-0.3,0.5-0.7,0.4-1.1c0-1.3,0.6-2.6,1.7-3.4c-1,0.9-1.6,2.2-1.6,3.6c0,2.7,2.2,4.9,4.9,4.9l0,0c2.7,0,4.9-2.2,4.9-4.9l0,0
    c0-1.4-0.6-2.8-1.7-3.7c1.1,0.8,1.8,2.1,1.8,3.5v0c0,0.4,0.2,0.8,0.4,1.1c0.3,0.3,0.7,0.4,1.1,0.4l42.4,0c0.4,0,0.9-0.2,1.2-0.5
    c0.2-0.2,0.3-0.4,0.4-0.6c0.1,2.6,2.3,4.7,4.9,4.7c2.7,0,4.9-2.2,4.9-4.9l0,0c0-1.1-0.4-2.2-1.1-3.1c0.7,0.8,1.1,1.8,1.1,2.9
    c0,0.3,0.1,0.5,0.3,0.7c0.7,0.5,1.5,0.8,2.4,0.8h0l0.5,0c0.4,0,0.7-0.2,1-0.4c0.1,0,0.1-0.1,0.2-0.1l1.4-0.7
    c0.7-0.4,1.3-1.1,1.4-1.9l0.5-2.4C125.2,38.3,125.2,37.8,125,37.2z M32.2,41.1L32.2,41.1c0,0.1,0,0.2,0,0.3
    c-0.8-0.1-1.4-0.7-1.4-1.5v-5c0-0.8,0.7-1.5,1.5-1.5h0.5L32.2,41.1z M56.1,12.6c0-0.3,0.3-0.6,0.6-0.6c0,0,0,0,0,0h7.5
    c0.1,0,0.2,0,0.3,0.1l1.4,0.7h-9.7L56.1,12.6z M60.5,43.1c0,2-1.6,3.5-3.5,3.5c-2,0-3.5-1.6-3.5-3.5c0-2,1.6-3.5,3.5-3.5
    C58.9,39.6,60.5,41.1,60.5,43.1L60.5,43.1z M74.4,43.1l-10.9,0c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1v0c-0.1-3.4-2.9-6.1-6.3-6
    c-3.4-0.1-6.2,2.6-6.3,6c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0l0,0l-5.6,0l-10-0.3c-0.8-0.1-1.4-0.8-1.4-1.6l0.2-2.8h16.9
    c0.3,0,0.6-0.1,0.8-0.3c1.5-1.4,3.4-2.1,5.4-2c1.8-0.1,3.6,0.6,4.9,2c0.2,0.3,0.6,0.4,0.9,0.4h11.6L74.4,43.1z M74.4,30.6H42.3
    c-0.4,0-0.9-0.2-1.1-0.5c-0.3-0.3-0.4-0.8-0.3-1.2l0.9-5.7l0,0c0.1-0.7,0.7-1.3,1.5-1.3h31.2L74.4,30.6z M74.4,21.3H43.2
    c-1,0-1.9,0.8-2.1,1.8l-0.9,5.7c-0.1,0.6,0.1,1.2,0.5,1.7c0.4,0.5,1,0.7,1.6,0.7h32.1v6.5H62.8c-0.2,0-0.3-0.1-0.5-0.2
    C61,36,59,35.2,57,35.3c-2.2-0.1-4.2,0.7-5.8,2.2c-0.1,0.1-0.3,0.2-0.4,0.2H33.9l1.5-17.5h39.1L74.4,21.3z M74.4,16.9H40.8
    c-0.2,0-0.3,0.1-0.3,0.3l0,0c0,0.2,0.1,0.3,0.3,0.3h0h33.6v2.2h-39l0.2-2.6V17c0.1-0.8,0.7-1.4,1.5-1.4c0.3,0,20.9,0,37.3,0
    L74.4,16.9z M94.1,43l-19.1,0v-4.7h19.1L94.1,43z M94.1,37.7H75v-6.5h14.6c1,0,1.9-0.7,2.1-1.8l1-5.7c0.1-0.6-0.1-1.2-0.5-1.7
    c-0.4-0.5-1-0.8-1.6-0.8H75v-1.1h19.1L94.1,37.7z M75,30.6v-8.7h15.6c0.4,0,0.9,0.2,1.2,0.5c0.3,0.3,0.4,0.8,0.3,1.2l-1,5.7
    c-0.1,0.7-0.8,1.3-1.5,1.3L75,30.6z M94.1,19.6H75v-2.2h19.1L94.1,19.6z M94.1,16.9H75v-1.3c8.6,0,16,0,18.6,0c0.2,0,0.4,0,0.6,0.1
    L94.1,16.9z M94.1,14.3c-0.2,0-0.4,0-0.6,0c-5.6,0-34.1,0-48.3,0v-0.3c0-0.3,0.3-0.6,0.6-0.6c0,0,0,0,0,0h47.7
    c0.3,0,0.6,0.3,0.6,0.6l0,0L94.1,14.3z M94.7,15.9c0.1,0,0.2,0.1,0.3,0.1l1.8,0.9h-2.1L94.7,15.9z M94.7,17.5h3.3l4.4,2.2h-7.7
    L94.7,17.5z M94.7,20.3h8.7c0.1,0,0.1,0,0.2,0l1,0.5l0.1,0c0.3,0.1,0.6,0.2,0.8,0.4l7.3,7.8c0.2,0.3,0.5,0.5,0.8,0.6l8.7,3.7
    c0.5,0.2,0.8,0.7,0.8,1.2l0.2,2c0,0.2,0.1,0.5,0.2,0.7l0.2,0.6l0,0h-5.3c-0.2,0-0.3-0.1-0.5-0.2c-1.4-1.5-3.3-2.3-5.4-2.2
    c-2.2-0.1-4.2,0.7-5.8,2.2c-0.1,0.1-0.3,0.2-0.4,0.2H94.7L94.7,20.3z M112.3,46.6c-2,0-3.5-1.6-3.5-3.5c0-2,1.6-3.5,3.5-3.5
    c2,0,3.5,1.6,3.5,3.5C115.9,45,114.3,46.6,112.3,46.6L112.3,46.6z M107.7,41.6c0.3-1.2,1.1-2.2,2.2-2.7
    C108.9,39.4,108.1,40.4,107.7,41.6L107.7,41.6z M123.8,38.6l-0.5,2.4c-0.1,0.4-0.4,0.8-0.8,1l-1.4,0.7c-0.1,0.1-0.2,0.1-0.3,0.2
    c-0.1,0.1-0.2,0.1-0.2,0.1l-0.5,0c-0.5,0-0.9-0.2-1.4-0.4c-0.2-3.3-3-5.9-6.3-5.8c-3.2-0.2-5.9,2.3-6.1,5.5c0,0.1,0,0.2,0,0.3
    c0,0.1,0,0.2-0.1,0.2C106,43,106,43,105.9,43l-11.1,0v-4.7h11.6c0.3,0,0.6-0.1,0.8-0.3c1.5-1.4,3.4-2.1,5.4-2
    c1.8-0.1,3.6,0.6,4.9,2c0.2,0.3,0.6,0.4,0.9,0.4h5.4C123.8,38.4,123.8,38.5,123.8,38.6L123.8,38.6z"
    ></path>
  </g>
  <g *ngIf="type === 'classC'">
    <path
      d="M99.2,16.9h-3.3c-0.7,0-1.2,0.5-1.2,1.2v1.6c0,0.7,0.5,1.2,1.2,1.2h3.3c0.7,0,1.2-0.5,1.2-1.2
    v-1.6C100.4,17.4,99.9,16.9,99.2,16.9z M99.8,19.7c0,0.3-0.3,0.6-0.6,0.6l0,0h-3.3c-0.3,0-0.6-0.3-0.6-0.6l0,0v-1.6
    c0-0.3,0.3-0.6,0.6-0.6l0,0h3.3c0.3,0,0.6,0.3,0.6,0.6l0,0V19.7z"
    ></path>
    <path
      d="M80.8,21H66.6c-0.7,0-1.2,0.5-1.2,1.2v6.4c0,0.7,0.5,1.2,1.2,1.2h14.1c0.7,0,1.2-0.5,1.2-1.2
    v-6.4C81.9,21.5,81.4,21,80.8,21z M81.4,28.6c0,0.3-0.3,0.6-0.6,0.6l0,0H66.6c-0.3,0-0.6-0.3-0.6-0.6l0,0v-6.4
    c0-0.3,0.3-0.6,0.6-0.6l0,0h14.1c0.3,0,0.6,0.3,0.6,0.6l0,0v6.4H81.4z"
    ></path>
    <path
      d="M88.8,24.2h-1.9c-0.7,0-1.2,0.5-1.2,1.2v5.2c0,0.7,0.5,1.2,1.2,1.2h1.9c0.7,0,1.2-0.5,1.2-1.2
    v-5.2C90,24.8,89.5,24.2,88.8,24.2z M89.4,30.6c0,0.3-0.3,0.6-0.6,0.6l0,0h-1.9c-0.3,0-0.6-0.3-0.6-0.6l0,0v-5.2
    c0-0.3,0.3-0.6,0.6-0.6l0,0h1.9c0.3,0,0.6,0.3,0.6,0.6l0,0V30.6z"
    ></path>
    <path
      d="M100.5,26.8c-0.2-0.2-0.5-0.4-0.8-0.4L96.1,26c-0.4,0-0.7,0.1-1,0.3c-0.3,0.3-0.4,0.6-0.4,1
    l0.4,4.2c0.1,0.5,0.4,1,1,1.1L104,34c0.1,0,0.2,0,0.2,0c0.4,0,0.8-0.2,1-0.6c0.3-0.4,0.2-1-0.1-1.4L100.5,26.8z M104.7,33.1
    c-0.1,0.2-0.4,0.3-0.6,0.3l-7.8-1.5c-0.3-0.1-0.5-0.3-0.5-0.5l-0.4-4.2c0-0.2,0-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.4-0.2c0,0,0,0,0.1,0
    l3.6,0.4c0.1,0,0.3,0.1,0.4,0.2l4.6,5.2l0,0C104.8,32.6,104.8,32.9,104.7,33.1z"
    ></path>
    <path
      d="M92.2,16.9H55.6c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2h36.6c0.7,0,1.2-0.5,1.2-1.2
    C93.4,17.4,92.9,16.9,92.2,16.9z M92.2,18.7H55.6c-0.3,0-0.6-0.3-0.6-0.6l0,0c0-0.3,0.3-0.6,0.6-0.6l0,0h36.6
    c0.3,0,0.6,0.3,0.6,0.6l0,0C92.8,18.4,92.6,18.7,92.2,18.7L92.2,18.7z"
    ></path>
    <path
      d="M62.4,34.2H57c-0.2,0-0.3,0.1-0.3,0.3l0,0c0,0.2,0.1,0.3,0.3,0.3l0,0h5.4
    c0.2,0,0.3-0.1,0.3-0.3l0,0C62.7,34.3,62.5,34.2,62.4,34.2L62.4,34.2z"
    ></path>
    <path
      d="M62.4,32.1H57c-0.2,0-0.3,0.1-0.3,0.3l0,0c0,0.2,0.1,0.3,0.3,0.3l0,0h5.4
    c0.2,0,0.3-0.1,0.3-0.3l0,0C62.7,32.2,62.5,32.1,62.4,32.1L62.4,32.1z"
    ></path>
    <path
      d="M62.4,33.1H57c-0.2,0-0.3,0.1-0.3,0.3l0,0c0,0.2,0.1,0.3,0.3,0.3l0,0h5.4
    c0.2,0,0.3-0.1,0.3-0.3l0,0C62.7,33.3,62.5,33.1,62.4,33.1L62.4,33.1z"
    ></path>
    <path
      d="M50.1,31.2h-6.4c-0.7,0-1.2,0.5-1.2,1.2v3.1c0,0.7,0.5,1.2,1.2,1.2h6.4c0.7,0,1.2-0.5,1.2-1.2
    v-3.1C51.3,31.7,50.8,31.2,50.1,31.2z M50.7,35.5c0,0.3-0.3,0.6-0.6,0.6l0,0h-6.4c-0.3,0-0.6-0.3-0.6-0.6l0,0v-3.1
    c0-0.3,0.3-0.6,0.6-0.6l0,0h6.4c0.3,0,0.6,0.3,0.6,0.6l0,0V35.5z"
    ></path>
    <path
      d="M115.9,39.1l-0.2-0.5c0-0.1-0.1-0.2-0.1-0.3l-0.2-1.6c-0.1-0.8-0.6-1.6-1.4-1.9l-6.1-3
    c-0.1-0.1-0.2-0.1-0.3-0.2l-5.9-6.3c-0.3-0.4-0.8-0.6-1.2-0.7l-4.4-1l9.7-0.3c0.7,0,1.4-0.4,1.9-1c0.7-0.8,1-2,0.7-3
    c-0.5-1.6-2.4-2.9-5.8-4c-6.3-1.8-12.7-2.9-19.2-3.2c-0.7,0-1.4,0.2-1.9,0.7l-1.9,1.9H64.2l-0.5-1.2c-0.2-0.5-0.6-0.8-1.1-0.8h-5.3
    c-0.5,0-1,0.3-1.1,0.8c-0.2,0.5-0.3,0.9-0.4,1.1h-14c-1.3,0-2.4,1.1-2.4,2.4v24.7c0,1.3,1,2.3,2.2,2.4L51.8,45h5.8l0,0
    c0.4,0,0.7-0.1,1-0.4c0.1-0.1,0.1-0.2,0.2-0.3c0.3,2,2,3.5,4,3.5c2.1,0,3.9-1.6,4.1-3.7c0.1,0.2,0.2,0.3,0.3,0.4
    c0.3,0.3,0.6,0.4,1,0.4H93c0.1,0,0.1,0,0.2,0h8c0.4,0,0.8-0.2,1-0.4l0.1-0.1c0.3,2,2,3.4,4,3.5c2.1,0,3.8-1.6,4.1-3.7
    c0.1,0.2,0.2,0.3,0.3,0.4c0.2,0.2,0.6,0.4,0.9,0.4l0,0h0.4c0.3,0,0.6-0.1,0.9-0.3c0.1,0,0.1-0.1,0.2-0.1l1.1-0.6
    c0.6-0.3,1.1-0.9,1.2-1.6l0.4-1.9C116.1,40.1,116,39.6,115.9,39.1z M56.8,13.7c0.1-0.2,0.3-0.4,0.6-0.4h5.3c0.2,0,0.5,0.1,0.6,0.4
    l0.4,1h-7C56.6,14.4,56.7,14.1,56.8,13.7L56.8,13.7z M47.4,43.4l-5.7-0.5c-0.6,0-1-0.5-1-1.1v-2.2h6.7V43.4z M56.7,43.8h-4.8
    L48,43.4v-3.8h8.7V43.8z M57.6,43.8L57.6,43.8h-0.3v-4.1H60C58.5,40.5,57.6,42.1,57.6,43.8L57.6,43.8z M62.8,46.7
    c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7C65.6,45.4,64.3,46.7,62.8,46.7L62.8,46.7z M68.5,43.8h-0.3l0,0
    c0-1.7-0.9-3.2-2.3-4.1h2.7L68.5,43.8z M82.2,43.8H69v-4.1h13.1L82.2,43.8L82.2,43.8z M84.5,43.8h-1.7v-4.1h1.7V43.8z M90.7,43.8
    H85V23.7c0-0.3,0.3-0.6,0.6-0.6h4.5c0.3,0,0.6,0.3,0.6,0.6V43.8z M92.4,43.8h-1.1v-4.1h1.1V43.8z M93.1,22.3
    c-0.2,0-0.5,0.1-0.6,0.4h-0.1V39h-1.1V23.7c0-0.7-0.5-1.2-1.2-1.2h-4.5c-0.7,0-1.2,0.5-1.2,1.2V39h-20c-0.5-0.2-1-0.2-1.6-0.2
    c-0.5,0-1.1,0.1-1.6,0.2H40.7V17c0-0.6,0.5-1.1,1.1-1.1h38c0.2,0,0.4-0.1,0.5-0.2l2.1-2.1c0.2-0.2,0.5-0.4,0.9-0.3
    c6.4,0.4,12.7,1.4,18.9,3.2c3.6,1.1,4.7,2.3,4.9,3.1c0.2,0.6,0,1.3-0.5,1.8c-0.2,0.3-0.5,0.4-0.9,0.4L93.1,22.3z M101.4,43.6
    C101.4,43.7,101.4,43.7,101.4,43.6C101.3,43.7,101.3,43.7,101.4,43.6l-7.6,0.1v-4.1h9.8C102.2,40.5,101.4,42,101.4,43.6L101.4,43.6
    z M106.4,46.7c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7C109.2,45.4,107.9,46.7,106.4,46.7L106.4,46.7z M108,39.1
    c-0.5-0.2-1-0.2-1.6-0.2c-0.5,0-1.1,0.1-1.6,0.2H93.7V24.3l6.5,1.5c0.2,0,0.4,0.2,0.6,0.3l5.9,6.3c0.2,0.2,0.4,0.4,0.7,0.5l6.1,3
    c0.3,0.2,0.6,0.5,0.6,0.9l0.2,1.6c0,0.2,0.1,0.4,0.1,0.5L108,39.1z M114.7,40.2l-0.4,1.9c-0.1,0.3-0.3,0.6-0.6,0.7l-1.1,0.6
    c-0.1,0.1-0.2,0.1-0.3,0.2c0,0-0.1,0.1-0.2,0.1h-0.4l0,0c0-1.7-0.9-3.3-2.3-4.1h5.3C114.7,39.8,114.7,40,114.7,40.2L114.7,40.2z"
    ></path>
  </g>
  <g *ngIf="type === 'fifthWheel'">
    <path
      d="M118.8,17.1h-2.9c-1.2,0-2.2,1-2.2,2.2v8.3c0,1.2,1,2.2,2.2,2.2h2.9c1.2,0,2.2-1,2.2-2.2v-8.3
    C121,18.1,120,17.1,118.8,17.1z M120.3,27.6c0,0.9-0.7,1.6-1.6,1.6h-2.9c-0.9,0-1.6-0.7-1.6-1.6v-8.3c0-0.9,0.7-1.6,1.6-1.6h2.9
    c0.9,0,1.6,0.7,1.6,1.6V27.6z"
    ></path>
    <path
      d="M95.6,34.3h-7.1c-0.7,0-1.3,0.6-1.3,1.3v4c0,0.7,0.6,1.3,1.3,1.3h7.1c0.7,0,1.3-0.6,1.3-1.3
    v-4C96.9,34.8,96.3,34.3,95.6,34.3z M96.3,39.5c0,0.3-0.3,0.6-0.6,0.6h-7.1c-0.3,0-0.6-0.3-0.6-0.6v-4c0-0.3,0.3-0.6,0.6-0.6h7.1
    c0.3,0,0.6,0.3,0.6,0.6V39.5z"
    ></path>
    <path
      d="M70,21.4H58.5c-0.7,0-1.3,0.6-1.3,1.3v9.6c0,0.7,0.6,1.3,1.3,1.3H70c0.7,0,1.3-0.6,1.3-1.3
    v-9.6C71.2,22,70.7,21.4,70,21.4z M70.6,32.3c0,0.3-0.3,0.6-0.6,0.6H58.5c-0.3,0-0.6-0.3-0.6-0.6v-9.6c0-0.3,0.3-0.6,0.6-0.6H70
    c0.3,0,0.6,0.3,0.6,0.6V32.3z"
    ></path>
    <path
      d="M50.2,23.9h-9.9c-0.7,0-1.3,0.6-1.3,1.3v7.1c0,0.7,0.6,1.3,1.3,1.3h9.9c0.7,0,1.3-0.6,1.3-1.3
    v-7.1C51.5,24.5,50.9,23.9,50.2,23.9z M50.9,32.3c0,0.3-0.3,0.6-0.6,0.6h-9.9c-0.3,0-0.6-0.3-0.6-0.6v-7.1c0-0.3,0.3-0.6,0.6-0.6
    h9.9c0.3,0,0.6,0.3,0.6,0.6V32.3z"
    ></path>
    <path
      d="M106.4,34.3h-6.6c-0.7,0-1.3,0.6-1.3,1.3v4c0,0.7,0.6,1.3,1.3,1.3h6.6c0.7,0,1.3-0.6,1.3-1.3
    v-4C107.7,34.8,107.1,34.3,106.4,34.3z M107,39.5c0,0.3-0.3,0.6-0.6,0.6h-6.6c-0.3,0-0.6-0.3-0.6-0.6v-4c0-0.3,0.3-0.6,0.6-0.6
    h6.6c0.3,0,0.6,0.3,0.6,0.6V39.5z"
    ></path>
    <path
      d="M108.7,17.1H56c-0.7,0-1.3,0.6-1.3,1.3V33c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.3-0.1,0.3-0.3V18.3
    c0-0.3,0.3-0.6,0.6-0.6h52.8c0.3,0,0.6,0.3,0.6,0.6V33c0,0.2,0.1,0.3,0.3,0.3s0.3-0.1,0.3-0.3V18.3
    C110,17.6,109.4,17.1,108.7,17.1z"
    ></path>
    <path
      d="M38.3,37.1c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5
    C39.7,37.8,39.1,37.1,38.3,37.1z M38.3,39.4c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8
    S38.7,39.4,38.3,39.4z"
    ></path>
    <path
      d="M47.4,39.3h-3.6c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.6c0.2,0,0.3-0.1,0.3-0.3
    S47.6,39.3,47.4,39.3z"
    ></path>
    <path
      d="M47.4,37.1h-3.6c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.6c0.2,0,0.3-0.1,0.3-0.3
    S47.6,37.1,47.4,37.1z"
    ></path>
    <path
      d="M47.4,38.2h-3.6c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.6c0.2,0,0.3-0.1,0.3-0.3
    S47.6,38.2,47.4,38.2z"
    ></path>
    <path
      d="M82.4,21.4h-3c-0.7,0-1.3,0.6-1.3,1.3v4.2c0,0.7,0.6,1.3,1.3,1.3h3c0.7,0,1.3-0.6,1.3-1.3
    v-4.2C83.6,22,83.1,21.4,82.4,21.4z M83,26.9c0,0.3-0.3,0.6-0.6,0.6h-3c-0.3,0-0.6-0.3-0.6-0.6v-4.2c0-0.3,0.3-0.6,0.6-0.6h3
    c0.3,0,0.6,0.3,0.6,0.6V26.9z"
    ></path>
    <path
      d="M131.3,24.2c-1-4.1-5-7.9-11.8-11.3c-0.9-0.5-1.9-0.7-2.9-0.7L67.9,12h0l-1,0.1l-17.2,2.4
    l-1.1-1.1c-0.5-0.5-1.2-0.7-1.9-0.6l-6.6,0.9c-1.1,0.2-1.9,1.1-1.9,2.2v0.2l-11.9,1.7c-1.4,0.2-2.5,1.4-2.5,2.8v9.5
    c0,4.5,1.8,8.8,5,12c0.5,0.5,1.2,0.8,1.9,0.8l22.8,0.6c0.3,0,0.6-0.1,0.8-0.2c0,0,0,0.1,0,0.1c0,2.6,2.1,4.6,4.6,4.6
    c2.6,0,4.6-2.1,4.6-4.6c0-0.1,0-0.1,0-0.2c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0.1,0.7,0,1.1-0.2c0,0,0,0.1,0,0.1c0,2.6,2.1,4.6,4.6,4.6
    c2.6,0,4.6-2.1,4.6-4.6c0-0.1,0-0.1,0-0.2c0.3,0.2,0.6,0.3,0.9,0.3l0,0l33.9,0c1.4,0,2.5-1,2.8-2.3l1-4.6c0.3-1.3,1.5-2.3,2.8-2.3
    h2.4l0.9,1.4h1.4c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.4,0.3,0.7,0.7,0.7l0,0h6.3c0.4,0,0.7-0.3,0.7-0.7l0,0c0-0.4-0.3-0.7-0.7-0.7l0,0
    h-2.8l-1-1.2h2c1.6,0,3-0.8,3.9-2.1C131.3,29.9,132,27,131.3,24.2z M38.8,15.9c0-0.8,0.6-1.5,1.4-1.6l6.6-0.9
    c0.5-0.1,1,0.1,1.3,0.5l0.7,0.7L38.8,15.9L38.8,15.9z M59,46.1c-1.5,0-2.7-1.2-2.7-2.7c0-1.5,1.2-2.7,2.7-2.7
    c1.5,0,2.7,1.2,2.7,2.7C61.7,44.9,60.5,46.1,59,46.1z M69.9,46.1c-1.5,0-2.7-1.2-2.7-2.7c0-1.5,1.2-2.7,2.7-2.7
    c1.5,0,2.7,1.2,2.7,2.7C72.6,44.9,71.4,46.1,69.9,46.1L69.9,46.1z M85,41.6h-8.1V20.7c0-0.4,0.3-0.6,0.6-0.6h6.9
    c0.4,0,0.6,0.3,0.6,0.6L85,41.6z M128,31.1c-0.5,0.8-1.4,1.2-2.4,1.2h-9.7c-2.3,0-4.2,1.6-4.7,3.8l-1,4.6
    c-0.1,0.4-0.5,0.8-0.9,0.8l-23.7,0V20.7c0-0.7-0.6-1.3-1.3-1.3h-6.9c-0.7,0-1.3,0.6-1.3,1.3v20.9h-0.5C75.1,38.9,72.8,37,70,37
    h-0.1c-2.3,0-4.4,1.3-5.4,3.4c-1-2.1-3.1-3.5-5.4-3.4c-2.8,0-5.2,1.9-5.8,4.6L30.8,41c-0.2,0-0.5-0.1-0.6-0.3
    c-2.8-2.8-4.4-6.6-4.4-10.6v-9.5c0-0.5,0.4-0.9,0.8-0.9L67.1,14l0.9-0.1l48.6,0.2c0.7,0,1.4,0.2,2.1,0.5c6.3,3.1,9.9,6.5,10.8,10
    C130,26.9,129.4,29.3,128,31.1L128,31.1z"
    ></path>
    <path
      d="M88.1,24.9h3.6c0.2,0,0.3-0.1,0.3-0.3s-0.1-0.3-0.3-0.3h-3.6c-0.2,0-0.3,0.1-0.3,0.3
    C87.8,24.8,87.9,24.9,88.1,24.9z"
    ></path>
    <path
      d="M88.1,22.7h3.6c0.2,0,0.3-0.1,0.3-0.3s-0.1-0.3-0.3-0.3h-3.6c-0.2,0-0.3,0.1-0.3,0.3
    C87.8,22.6,87.9,22.7,88.1,22.7z"
    ></path>
    <path
      d="M88.1,23.8h3.6c0.2,0,0.3-0.1,0.3-0.3s-0.1-0.3-0.3-0.3h-3.6c-0.2,0-0.3,0.1-0.3,0.3
    S87.9,23.8,88.1,23.8z"
    ></path>
  </g>
  <g *ngIf="type === 'travelTrailer'">
    <path
      d="M88.4,19v14.1c0,0.2,0.1,0.3,0.3,0.3s0.3-0.1,0.3-0.3V19c0-0.7-0.5-1.2-1.2-1.2H25.7
    c-0.7,0-1.2,0.5-1.2,1.2v14.1c0,0.2,0.1,0.3,0.3,0.3s0.3-0.1,0.3-0.3V19c0-0.3,0.3-0.6,0.6-0.6l0,0h62.1
    C88.1,18.4,88.4,18.7,88.4,19z"
    ></path>
    <path
      d="M64,21.5H49.2c-0.7,0-1.2,0.5-1.2,1.2v9.9c0,0.7,0.5,1.2,1.2,1.2H64c0.7,0,1.2-0.5,1.2-1.2
    v-9.9C65.2,22,64.6,21.5,64,21.5z M64.6,32.5c0,0.3-0.3,0.6-0.6,0.6l0,0H49.2c-0.3,0-0.6-0.3-0.6-0.6v0v-9.9c0-0.3,0.3-0.6,0.6-0.6
    l0,0H64c0.3,0,0.6,0.3,0.6,0.6v0L64.6,32.5z"
    ></path>
    <path
      d="M91.7,30.4h10.2c0.7,0,1.2-0.5,1.2-1.2v-6.6c0-0.7-0.5-1.2-1.2-1.2H91.7
    c-0.7,0-1.2,0.5-1.2,1.2v6.6C90.5,29.9,91,30.4,91.7,30.4z M91.1,22.7c0-0.3,0.3-0.6,0.6-0.6l0,0h10.2c0.3,0,0.6,0.3,0.6,0.6v0v6.6
    c0,0.3-0.3,0.6-0.6,0.6l0,0H91.7c-0.3,0-0.6-0.3-0.6-0.6v0V22.7z"
    ></path>
    <path
      d="M72.2,36.6c-1.2,0-2.1,1-2.1,2.1c0,1.2,1,2.1,2.1,2.1c1.2,0,2.1-1,2.1-2.1
    C74.3,37.5,73.4,36.6,72.2,36.6z M72.2,40.2c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5
    C73.7,39.5,73,40.2,72.2,40.2L72.2,40.2z"
    ></path>
    <path
      d="M34,21.5h-2.8c-0.7,0-1.2,0.5-1.2,1.2v5.9c0,0.7,0.5,1.2,1.2,1.2H34c0.7,0,1.2-0.5,1.2-1.2
    v-5.9C35.2,22,34.6,21.5,34,21.5z M34.6,28.6c0,0.3-0.3,0.6-0.6,0.6l0,0h-2.8c-0.3,0-0.6-0.3-0.6-0.6v0v-5.9c0-0.3,0.3-0.6,0.6-0.6
    l0,0H34c0.3,0,0.6,0.3,0.6,0.6v0V28.6z"
    ></path>
    <path
      d="M79.5,24.1h-3.4c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.4c0.2,0,0.3-0.1,0.3-0.3
    S79.7,24.1,79.5,24.1z"
    ></path>
    <path
      d="M79.5,22.1h-3.4c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.4c0.2,0,0.3-0.1,0.3-0.3
    S79.7,22.1,79.5,22.1z"
    ></path>
    <path
      d="M79.5,23.1h-3.4c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.4c0.2,0,0.3-0.1,0.3-0.3
    S79.7,23.1,79.5,23.1z"
    ></path>
    <path
      d="M94.3,36.8h-4.4c-0.7,0-1.2,0.5-1.2,1.2v1.6c0,0.7,0.5,1.2,1.2,1.2h4.4c0.7,0,1.2-0.5,1.2-1.2
    V38C95.5,37.3,95,36.8,94.3,36.8z M94.9,39.6c0,0.3-0.3,0.6-0.6,0.6l0,0h-4.4c-0.3,0-0.6-0.3-0.6-0.6v0V38c0-0.3,0.3-0.6,0.6-0.6
    l0,0h4.4c0.3,0,0.6,0.3,0.6,0.6v0V39.6z"
    ></path>
    <path
      d="M136,39.8h-3.2v-3.7c0-0.4-0.3-0.7-0.7-0.7l0,0c-0.4,0-0.7,0.3-0.7,0.7l0,0v3.7h-6.4
    c0.1-0.4,0.1-0.9-0.1-1.3l-0.7-1.9c-0.4-0.9-1.2-1.6-2.2-1.7l0,0h-3.9c-0.5-5.5-4.2-12.9-18-19.3c-0.8-0.4-1.7-0.6-2.6-0.6
    l-39.1-0.3l-1.2-1.8c-0.4-0.6-1-0.9-1.7-0.9H45.5c-0.8,0-1.5,0.4-1.8,1.1l-0.8,1.5l-17.4-0.1c-1.2,0-2.4,0.3-3.4,1l-0.4,0.3
    c-1.8,1.1-2.9,3.1-2.9,5.2v15.8c0,0.7,0.3,1.4,0.8,1.9l3.8,3.8c0.5,0.5,1.1,0.7,1.8,0.8l2.8,0.1c0,0,0,0,0.1,0c0,0,0,0,0,0
    l18.3,0.5l0,0c0.3,0,0.5-0.1,0.7-0.2c0,0,0,0.1,0,0.1c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.9,4.3-4.3c0-0.1,0-0.1,0-0.2
    c0.2,0.2,0.5,0.3,0.8,0.3c0.2,0,0.5-0.1,0.7-0.2c0,0,0,0.1,0,0.1c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.9,4.3-4.3c0-0.1,0-0.1,0-0.2
    c0.2,0.2,0.5,0.3,0.8,0.3l0,0l48.1,0c1,0,1.9-0.5,2.3-1.4l5.4,0h0c0.8,0,1.6-0.4,2-1.1l0.1-0.1h7.1v3h-0.1c-1,0-1.8,0.8-1.8,1.8
    c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8c0-0.4-0.1-0.8-0.4-1.1v-3.6h3.2c0.4,0,0.7-0.3,0.7-0.7l0,0
    C136.7,40.2,136.4,39.9,136,39.8C136,39.8,136,39.8,136,39.8z M44.2,13.4c0.3-0.5,0.8-0.8,1.3-0.8h10.1c0.5,0,1,0.2,1.2,0.7l1,1.5
    l-14.3-0.1L44.2,13.4z M27.6,41.5l-2.5-0.1c-0.2,0-0.4-0.1-0.6-0.3l-3.8-3.8c-0.2-0.2-0.3-0.4-0.3-0.6v-0.6h7.1L27.6,41.5z
    M36.8,41.8l-8.6-0.2V20.9c0-0.3,0.3-0.6,0.6-0.6h7.4c0.3,0,0.6,0.2,0.6,0.6L36.8,41.8z M36.2,19.7h-7.4c-0.6,0-1.2,0.5-1.2,1.2
    v14.7h-7.1V21c0-1.5,0.8-2.9,2.1-3.7l0.4-0.3c0.7-0.5,1.6-0.7,2.4-0.7l72.2,0.6c0.6,0,1.3,0.2,1.9,0.4c8.8,4.1,14.3,9,16.2,14.5
    c0.4,1.1,0.6,2.3,0.7,3.5h-1.5v-0.6c0-0.7-0.5-1.2-1.2-1.2h-9.5c-0.7,0-1.2,0.5-1.2,1.2l0,0v0.9H37.4V20.9
    C37.4,20.2,36.9,19.7,36.2,19.7L36.2,19.7z M114.3,35.6v3.9c0,0.3-0.3,0.6-0.6,0.6h-9.5c-0.3,0-0.6-0.3-0.6-0.6v-4.9
    c0-0.3,0.3-0.6,0.6-0.6h9.5c0.3,0,0.6,0.3,0.6,0.6V35.6C114.3,35.6,114.3,35.6,114.3,35.6C114.3,35.6,114.3,35.6,114.3,35.6
    L114.3,35.6z M51.3,46.2c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5C53.8,45.1,52.7,46.2,51.3,46.2
    L51.3,46.2z M61.4,46.2c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5C63.9,45.1,62.8,46.2,61.4,46.2
    L61.4,46.2z M115.4,41.5c-0.1,0.3-0.5,0.5-0.8,0.5l-47.8,0c-0.5-2.5-2.7-4.3-5.3-4.2h-0.1c-2.2,0-4.1,1.2-5,3.2
    c-0.9-2-2.9-3.2-5-3.2c-2.5,0-4.8,1.7-5.4,4.2l-8.6-0.2v-5.6h65.6v3.4c0,0.7,0.5,1.2,1.2,1.2h9.5c0.7,0,1.2-0.5,1.2-1.2v-3.6h1.6
    C116.5,37.8,116.2,39.7,115.4,41.5L115.4,41.5z M123.6,40L123.6,40c-0.1,0.1-0.1,0.2-0.1,0.2l-0.2,0.3c-0.2,0.3-0.6,0.5-0.9,0.5
    l-4.8,0c0.5-1.5,0.8-3.1,0.8-4.8h3.7c0.5,0.1,0.9,0.4,1.1,0.8l0.7,1.9C123.8,39.3,123.8,39.7,123.6,40L123.6,40z M131.4,46.4
    c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0,0,0.1,0,0.1,0c0.1,0.1,0.2,0.3,0.3,0.3c0,0,0,0.1,0,0.1
    C131.9,46.2,131.7,46.4,131.4,46.4L131.4,46.4z"
    ></path>
  </g>
  <g *ngIf="type === 'truckCamper'">
    <path
      d="M111.3,38.8c-0.1-0.1-0.1-0.2-0.1-0.4v-3.9c0-1-0.8-1.9-1.9-1.9h-9.9c-0.2,0-0.5-0.1-0.6-0.2
    l-5.1-3.7h2.4c0.9,0,1.7-0.4,2.3-1c0.6-0.6,0.9-1.5,0.8-2.3c-0.3-3.6-3.5-6.7-4.8-7.8c-0.4-0.4-1-0.6-1.5-0.7L72,13.2
    c-0.2,0-0.4-0.1-0.6,0l-5.2,0.2l-0.9-0.9c-0.2-0.2-0.5-0.4-0.9-0.4h-6.8c-0.7,0-1.2,0.6-1.2,1.2v0.4l-9.6,0.3c-1.7,0-3,1.4-3,3.1
    v21.2c0,0.8,0.3,1.6,0.9,2.2l0.1,0.1c0.6,0.6,1.4,0.9,2.2,0.9h2.6c0.2,0,0.5,0,0.7-0.1c0,0.8,0.3,1.6,0.8,2.2
    c0.3,0.4,0.9,0.6,1.4,0.6h3.7c1.4,0,2.6-1.2,2.5-2.6v-1.4c0-0.1,0.1-0.3,0.1-0.4l1.1-1.1c0.1-0.1,0.2-0.1,0.3-0.1h4.2
    c0.1,0,0.2,0.1,0.3,0.1l1.6,1.7c0.1,0.1,0.1,0.1,0.1,0.1v2.2c0,0.1,0,0.2,0,0.3c-0.4-1.9-2.1-3.3-4.1-3.3c-2.3,0-4.1,1.9-4.1,4.1
    c0,2.3,1.9,4.1,4.1,4.1c2.3,0,4.1-1.9,4.1-4.1c0-0.2,0-0.4,0-0.6c0.3,1.2,1.3,2,2.5,2h26.7c1.4,0,2.6-1.2,2.5-2.6v-2.2
    c0-0.1,0.1-0.3,0.1-0.4l1.4-1.5c0.1-0.1,0.2-0.1,0.3-0.1h4.3c0.1,0,0.2,0.1,0.3,0.1l1.7,1.8c0.1,0.1,0.1,0.2,0.1,0.4v2.5
    c0,1,0.8,1.9,1.9,1.9h0.5c0.5,0,1-0.2,1.3-0.6l1.1-1.1c0.3-0.4,0.5-0.8,0.5-1.3v-2.1C111.9,39.7,111.7,39.2,111.3,38.8z M62.3,46.6
    c-1.5,0-2.8-1.2-2.8-2.8c0-1.5,1.2-2.8,2.8-2.8c1.5,0,2.8,1.2,2.8,2.8C65.1,45.4,63.9,46.6,62.3,46.6L62.3,46.6z M56.8,13.2
    c0-0.3,0.3-0.6,0.6-0.6h6.9c0.2,0,0.3,0.1,0.4,0.2l0.5,0.5l-8.4,0.3V13.2z M44.9,17c0-0.9,0.7-1.7,1.7-1.7l24.8-0.8h0.1
    c0.1,0,0.2,0,0.3,0l20.9,3.7c0.3,0.1,0.6,0.2,0.8,0.4c0.5,0.4,0.9,0.9,1.4,1.3h-5.3v-0.2c0-0.7-0.6-1.2-1.2-1.2h-8.2
    c-0.7,0-1.2,0.6-1.2,1.2v0.2h-7c-0.1-0.6-0.6-1.1-1.2-1.1h-4.1c-0.6,0-1.2,0.5-1.2,1.1h-6c-0.1-0.6-0.6-1.1-1.2-1.1h-8
    c-0.6,0-1.2,0.5-1.2,1.1h-3.9L44.9,17z M88.9,19.7v4.6c0,0.3-0.3,0.6-0.6,0.6h-8.2c-0.3,0-0.6-0.3-0.6-0.6v-4.6
    c0-0.3,0.3-0.6,0.6-0.6h8.2C88.7,19.1,88.9,19.4,88.9,19.7C88.9,19.7,88.9,19.7,88.9,19.7L88.9,19.7z M71.3,20v2.3
    c0,0.3-0.3,0.6-0.6,0.6h-4.1c-0.3,0-0.6-0.3-0.6-0.6V20c0-0.3,0.3-0.6,0.6-0.6h4.1C71,19.4,71.3,19.7,71.3,20
    C71.3,20,71.3,20,71.3,20L71.3,20z M58.7,20v3.9c0,0.3-0.3,0.6-0.6,0.6h-8c-0.3,0-0.6-0.3-0.6-0.6V20c0-0.3,0.3-0.6,0.6-0.6h8
    C58.4,19.4,58.7,19.7,58.7,20C58.7,20,58.7,20,58.7,20L58.7,20z M57.1,41.5c0,0.7-0.5,1.2-1.2,1.2h-3.7c-0.1,0-0.3-0.1-0.3-0.2
    c-0.4-0.5-0.5-1.1-0.4-1.6h5.6L57.1,41.5z M74.9,43.9h-6c-0.7,0-1.2-0.6-1.2-1.2v-1.7h7.1L74.9,43.9z M74.9,40.3h-7.2
    c0-0.3-0.2-0.6-0.4-0.8c0,0-0.1-0.1-0.1-0.1l-1.6-1.7c-0.3-0.4-0.8-0.6-1.3-0.6H60c-0.5,0-1,0.2-1.3,0.6l-1.1,1.1
    c-0.3,0.4-0.5,0.8-0.5,1.3v0.2h-5.4c0.5-0.6,0.8-1.3,0.8-2v-1.4c0-1,0.8-1.7,1.7-1.7h19.1c0.6,0,1.1-0.1,1.6-0.4L74.9,40.3z
    M75.1,32c0,1-0.8,1.7-1.7,1.7H54.2c-1.7,0-3.1,1.4-3.1,3.1v1.4c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.8,0.5-1.2,0.5h-2.6
    c-0.5,0-0.9-0.2-1.2-0.5l-0.1-0.1c-0.3-0.3-0.5-0.8-0.5-1.2V20.5h3.9v3.4c0,0.7,0.6,1.2,1.2,1.2h8c0.7,0,1.2-0.6,1.2-1.2v-3.4h6
    v1.8c0,0.7,0.6,1.2,1.2,1.2h4.1c0.7,0,1.2-0.6,1.2-1.2v-1.8h7v3.8c0,0.7,0.6,1.2,1.2,1.2h8.2c0.7,0,1.2-0.6,1.2-1.2v-3.8h5.9
    c1.3,1.4,2.1,3.1,2.4,5c0,0.5-0.1,0.9-0.4,1.3c-0.3,0.4-0.8,0.6-1.3,0.6H78.2c-1.7,0-3.1,1.4-3.1,3.1L75.1,32z M96.7,42.7
    c0,0.7-0.5,1.2-1.2,1.2h-20v-3h21.2L96.7,42.7z M110.5,42.2c0,0.1-0.1,0.3-0.1,0.4l-1.1,1.1c-0.1,0.1-0.2,0.1-0.3,0.1h-0.5
    c-0.3,0-0.5-0.2-0.5-0.5v-2.4h2.5L110.5,42.2z M110.5,40.3h-2.6c-0.1-0.3-0.2-0.6-0.5-0.8l-1.7-1.8c-0.3-0.4-0.8-0.6-1.3-0.6H100
    c-0.5,0-1,0.2-1.3,0.6l-1.4,1.5c-0.3,0.3-0.5,0.7-0.5,1.1H75.5v-6.1c0.6-0.6,0.9-1.4,0.9-2.2v-1.5c0-0.8,0.5-1.4,1.2-1.7
    c0.1,0,0.1,0,0.2,0h13.6c0.1,0,0.2,0,0.3,0.1l6.3,4.6c0.4,0.3,0.9,0.5,1.5,0.5h9.9c0.3,0,0.5,0.2,0.5,0.5v3.9c0,0.5,0.2,1,0.5,1.3
    c0.1,0.1,0.1,0.2,0.1,0.4L110.5,40.3z"
    ></path>
    <path
      d="M61.9,32h-3.3c-0.2,0-0.3,0.1-0.3,0.3l0,0c0,0.2,0.1,0.3,0.3,0.3c0,0,0,0,0,0h3.3
    c0.2,0,0.3-0.1,0.3-0.3l0,0C62.2,32.2,62.1,32,61.9,32C61.9,32,61.9,32,61.9,32z"
    ></path>
    <path
      d="M61.9,30.2h-3.3c-0.2,0-0.3,0.1-0.3,0.3l0,0c0,0.2,0.1,0.3,0.3,0.3c0,0,0,0,0,0h3.3
    c0.2,0,0.3-0.1,0.3-0.3l0,0C62.2,30.4,62.1,30.2,61.9,30.2C61.9,30.2,61.9,30.2,61.9,30.2z"
    ></path>
    <path
      d="M61.9,31.1h-3.3c-0.2,0-0.3,0.1-0.3,0.3l0,0c0,0.2,0.1,0.3,0.3,0.3c0,0,0,0,0,0h3.3
    c0.2,0,0.3-0.1,0.3-0.3l0,0C62.2,31.3,62.1,31.1,61.9,31.1C61.9,31.1,61.9,31.1,61.9,31.1z"
    ></path>
    <path
      d="M51.6,30.2c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6
    C53.2,30.9,52.5,30.2,51.6,30.2z M51.6,32.8c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1C52.6,32.4,52.1,32.8,51.6,32.8z"
    ></path>
    <path
      d="M47.8,33.5c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6
    C46.2,32.7,46.9,33.5,47.8,33.5z M47.8,30.8c0.6,0,1,0.5,1,1c0,0.6-0.5,1-1,1c-0.6,0-1-0.5-1-1C46.8,31.3,47.2,30.8,47.8,30.8
    L47.8,30.8z"
    ></path>
    <path
      d="M48.7,35.9h-1.5c-0.7,0-1.3,0.6-1.3,1.3l0,0c0,0.7,0.6,1.3,1.3,1.3c0,0,0,0,0,0h1.5
    c0.7,0,1.3-0.6,1.3-1.3l0,0C50,36.5,49.4,35.9,48.7,35.9C48.7,35.9,48.7,35.9,48.7,35.9z M48.7,37.9h-1.5c-0.4,0-0.7-0.3-0.7-0.7
    c0-0.4,0.3-0.7,0.7-0.7h1.5c0.4,0,0.7,0.3,0.7,0.7C49.3,37.5,49,37.9,48.7,37.9L48.7,37.9z"
    ></path>
    <path
      d="M71.9,28.6h-4.3c-0.7,0-1.2,0.6-1.2,1.2v1.6c0,0.7,0.6,1.2,1.2,1.2h4.3c0.7,0,1.2-0.6,1.2-1.2
    v-1.6C73.2,29.2,72.6,28.6,71.9,28.6z M72.6,31.4c0,0.3-0.3,0.6-0.6,0.6h-4.3c-0.3,0-0.6-0.3-0.6-0.6v-1.6c0-0.3,0.3-0.6,0.6-0.6
    h4.3c0.3,0,0.6,0.3,0.6,0.6V31.4z"
    ></path>
    <path
      d="M95.5,33.2l-4.7-3.4c-0.2-0.1-0.4-0.2-0.7-0.2h-3.1c-0.6,0-1.1,0.5-1.1,1.1v3.4
    c0,0.6,0.5,1.1,1.1,1.1h7.8c0.6,0,1.1-0.5,1.1-1.1C95.9,33.7,95.8,33.4,95.5,33.2z M94.8,34.6h-7.8c-0.3,0-0.5-0.2-0.5-0.5v-3.4
    c0-0.3,0.2-0.5,0.5-0.5h3.1c0.1,0,0.2,0,0.3,0.1l4.7,3.4c0.1,0.1,0.2,0.2,0.2,0.4C95.3,34.4,95.1,34.6,94.8,34.6L94.8,34.6z"
    ></path>
    <path
      d="M83.2,29.6h-4.8c-0.6,0-1.1,0.5-1.1,1.1v3.4c0,0.6,0.5,1.1,1.1,1.1h4.8c0.6,0,1.1-0.5,1.1-1.1
    v-3.4C84.3,30.1,83.8,29.6,83.2,29.6z M83.7,34.1c0,0.3-0.2,0.5-0.5,0.5h-4.8c-0.3,0-0.5-0.2-0.5-0.5v-3.4c0-0.3,0.2-0.5,0.5-0.5
    h4.8c0.3,0,0.5,0.2,0.5,0.5V34.1z"
    ></path>
    <path
      d="M102.3,39.6c-2.3,0-4.2,1.9-4.2,4.2c0,2.3,1.9,4.2,4.2,4.2c2.3,0,4.2-1.9,4.2-4.2
    C106.4,41.5,104.6,39.6,102.3,39.6z M102.3,46.6c-1.5,0-2.8-1.2-2.8-2.8c0-1.5,1.2-2.8,2.8-2.8c1.5,0,2.8,1.2,2.8,2.8
    C105,45.4,103.8,46.6,102.3,46.6z"
    ></path>
  </g>
  <g *ngIf="type === 'teardrop'">
    <path
      d="M76.4,18.6H65.5c-1.3,0-2.3,1-2.3,2.3v3.5c0,1.3,1,2.3,2.3,2.3h10.9c1.3,0,2.3-1,2.3-2.3V21
    C78.7,19.7,77.7,18.6,76.4,18.6z M78.1,24.5c0,0.9-0.7,1.7-1.7,1.7H65.5c-0.9,0-1.7-0.7-1.7-1.7V21c0-0.9,0.7-1.7,1.7-1.7h10.9
    c0.9,0,1.7,0.7,1.7,1.7V24.5z"
    ></path>
    <path
      d="M97.5,28.2H93c-0.2,0-0.3,0.1-0.3,0.3c0,0,0,0,0,0c0,0.2,0.1,0.3,0.3,0.3c0,0,0,0,0,0h4.4
    c0.2,0,0.3-0.1,0.3-0.3v0C97.8,28.4,97.6,28.2,97.5,28.2L97.5,28.2z"
    ></path>
    <path
      d="M97.5,27.4H93c-0.2,0-0.3,0.1-0.3,0.3c0,0,0,0,0,0c0,0.2,0.1,0.3,0.3,0.3c0,0,0,0,0,0h4.4
    c0.2,0,0.3-0.1,0.3-0.3v0C97.8,27.6,97.6,27.4,97.5,27.4L97.5,27.4z"
    ></path>
    <path
      d="M97.5,26.6H93c-0.2,0-0.3,0.1-0.3,0.3c0,0,0,0,0,0c0,0.2,0.1,0.3,0.3,0.3c0,0,0,0,0,0h4.4
    c0.2,0,0.3-0.1,0.3-0.3v0C97.8,26.7,97.6,26.6,97.5,26.6L97.5,26.6z"
    ></path>
    <path
      d="M87.5,20.1c-1.6,0-2.9,1.3-2.9,2.9c0,1.6,1.3,2.9,2.9,2.9c1.6,0,2.9-1.3,2.9-2.9
    C90.4,21.4,89.1,20.1,87.5,20.1z M87.5,25.2c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2
    C89.7,24.2,88.7,25.2,87.5,25.2z"
    ></path>
    <path
      d="M74.7,37.8c-2.8,0-5.1,2.3-5.1,5.1c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1
    C79.9,40,77.6,37.8,74.7,37.8z M74.7,46.5c-2,0-3.6-1.6-3.6-3.6c0-2,1.6-3.6,3.6-3.6c2,0,3.6,1.6,3.6,3.6
    C78.4,44.9,76.7,46.5,74.7,46.5L74.7,46.5z"
    ></path>
    <path
      d="M108.3,40.8h-1.5V36c0-0.4-0.3-0.7-0.7-0.7s-0.7,0.3-0.7,0.7v4.8h-1.9c0-0.1,0-0.2,0-0.2v-6.4
    c0-0.7-0.6-1.3-1.3-1.3H100l0.7-1.9c0.2-0.6,0.3-1.2,0.3-1.8c-0.3-9.1-5.7-13.3-10.1-15.2c-3-1.3-6.3-1.9-9.5-1.9
    c-10,0-18.4,2.8-25.1,8.4c-4.2,3.6-7.5,8-9.6,13c-0.4,0.8-0.4,1.7,0,2.6c0.3,0.8,1,1.5,1.8,1.8c5.7,2.6,11.9,4,18.1,4.3h0.1
    c1,0,2-0.6,2.4-1.5c1-2.2,3.3-3.6,5.7-3.5c2.4-0.1,4.6,1.2,5.5,3.4c0.4,1,1.4,1.6,2.5,1.6h22.6v5c0,0.4,0.3,0.7,0.7,0.7
    s0.7-0.3,0.7-0.7v-5h1.5c0.4,0,0.7-0.3,0.7-0.7C109,41.1,108.7,40.8,108.3,40.8L108.3,40.8z M91.5,40.8h-8.1V21.8
    c0-2.2,1.8-4.1,4.1-4.1c2.2,0,4.1,1.8,4.1,4.1L91.5,40.8z M93.2,40.8h-1.1V21.8c0-2.6-2.1-4.7-4.7-4.7c-2.6,0-4.7,2.1-4.7,4.7v18.9
    c-0.5,0-0.9-0.3-1.1-0.7c-1.2-2.7-3.9-4.4-6.9-4.3c-3-0.1-5.8,1.6-7,4.4c-0.2,0.4-0.6,0.7-1.1,0.7c-6.1-0.3-12-1.7-17.6-4.2
    c-0.5-0.2-0.8-0.6-1-1c-0.2-0.5-0.2-1,0-1.5c2.6-6.2,11.2-20.6,33.4-20.6h0c3.1,0,6.1,0.6,8.9,1.8c5.9,2.5,9,7.2,9.2,13.9
    c0,0.4-0.1,0.8-0.2,1.2l-3.1,8.3C95.8,39.9,94.6,40.8,93.2,40.8z M102.8,40.5c0,0.1,0,0.2,0,0.2h-6.1c0.4-0.4,0.8-1,1-1.6l2.1-5.7
    h2.3c0.4,0,0.7,0.3,0.7,0.7V40.5z"
    ></path>
  </g>
  <g *ngIf="type === 'popup'">
    <path
      d="M108.4,40h-0.7v-3.3c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0,0,0,0,0V40h-2.8v-4.3
    c0-0.6-0.5-1.1-1.1-1.1h-1.8c-0.6,0-1.1,0.5-1.1,1.1V40h-0.8v-2.8c0-0.5-0.4-1-0.9-1.1l-5.4-0.9v-0.1c0-0.6-0.2-1.1-0.5-1.6
    c0.1-0.1,0.1-0.2,0.2-0.2c0.3-0.5,0.3-1.1,0.1-1.6l-0.4-0.7C91.6,30.4,91,30,90.4,30H50.7c-0.6,0-1.2,0.3-1.5,0.9l-0.4,0.7
    c-0.3,0.5-0.3,1.2,0,1.7c0.1,0.1,0.1,0.2,0.2,0.3c-0.3,0.4-0.4,0.9-0.4,1.3c-0.2-0.2-0.5-0.3-0.8-0.3h-0.6c-0.6,0-1.1,0.5-1.1,1.1
    v6.1c0,0.6,0.5,1.1,1.1,1.1h0.6c0.6,0,1.1-0.5,1.1-1.1v-0.7h2.7c0.3,0.2,0.6,0.4,1,0.5L51,47.1c0,0.1,0,0.3,0.2,0.3c0,0,0,0,0,0
    c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.3-0.2l1.8-5.6h9.1c0.5,0,0.9-0.1,1.3-0.4c-0.4,0.7-0.6,1.5-0.6,2.3c0,2.5,2,4.5,4.5,4.5
    c2.5,0,4.5-2,4.5-4.5c0-0.7-0.2-1.4-0.5-2.1c0.2,0.1,0.5,0.2,0.8,0.2h16.5c0,0,0.1,0,0.1,0H93l5.3,5.7c0.1,0.1,0.1,0.1,0.2,0.1
    c0.1,0,0.1,0,0.2-0.1c0.1-0.1,0.1-0.3,0-0.4c0,0,0,0,0,0L96,44l2.4-2.4h8v2.7c-0.1,0-0.1,0-0.2,0c-0.9,0-1.7,0.7-1.7,1.7
    c0,0.9,0.7,1.7,1.7,1.7c0.9,0,1.7-0.7,1.7-1.7c0-0.3-0.1-0.6-0.2-0.9v-3.5h0.7c0.5,0,0.8-0.4,0.8-0.8C109.2,40.4,108.9,40,108.4,40
    z M48.5,41.8c0,0.3-0.2,0.6-0.6,0.6c0,0,0,0,0,0h-0.6c-0.3,0-0.6-0.2-0.6-0.6c0,0,0,0,0,0v-6.1c0-0.3,0.2-0.6,0.6-0.6l0,0h0.6
    c0.3,0,0.6,0.2,0.6,0.6c0,0,0,0,0,0V41.8z M50.7,31.7h39.6l0.4,0.7h-0.6c-0.1,0-0.1,0-0.2,0H51.2c-0.1,0-0.1,0-0.2,0h-0.7
    L50.7,31.7z M49,40.5V38c0.1,0.2,0.2,0.3,0.3,0.5l1.8,2H49z M67.5,46.3c-1.5,0-2.8-1.2-2.8-2.8c0-1.5,1.2-2.8,2.8-2.8
    c1.5,0,2.8,1.2,2.8,2.8C70.3,45.1,69.1,46.3,67.5,46.3L67.5,46.3z M72.3,40L72.3,40l-0.1-0.1c-0.5-0.7-1.5-2.3-4.9-2.3
    c-1.6,0-3.2,0.7-4.2,2c-0.2,0.2-0.4,0.3-0.7,0.4h-9.2c-0.2,0-0.4-0.1-0.6-0.3l-2.1-2.3c-0.2-0.2-0.3-0.5-0.3-0.8l0-1.6
    c0-0.5,0.3-0.9,0.7-1h21.3L72.3,40z M78.7,40h-5.8v-5.9h5.8V40z M90.8,39c0,0.5-0.3,1-0.8,1h-4.2h-6.5v-5.9h10.8
    c0.5,0.1,0.8,0.5,0.7,1V39z M95.6,43.6l-1.8-2h3.8L95.6,43.6z M98.3,40h-6c0.1-0.3,0.2-0.7,0.2-1v-3.2l5.3,0.9
    c0.3,0,0.5,0.3,0.5,0.6L98.3,40z M103,40h-2.9v-4.3c0-0.3,0.2-0.6,0.6-0.6h1.8c0.3,0,0.6,0.2,0.6,0.6L103,40z M106.3,46.5
    c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C106.7,46.3,106.5,46.5,106.3,46.5L106.3,46.5z"
    ></path>
    <path
      d="M83.7,35h-2.8c-0.6,0-1,0.5-1,1v2.8c0,0.6,0.5,1,1,1h2.8c0.6,0,1-0.5,1-1V36
    C84.8,35.4,84.3,35,83.7,35z M84.2,38.8c0,0.3-0.2,0.5-0.5,0.5h-2.8c-0.3,0-0.5-0.2-0.5-0.5V36c0-0.3,0.2-0.5,0.5-0.5h2.8
    c0.3,0,0.5,0.2,0.5,0.5V38.8z"
    ></path>
    <path
      d="M70.7,37.8c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9
    C69.8,37.4,70.2,37.8,70.7,37.8z M70.7,36.6c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3l0,0
    C70.3,36.7,70.5,36.6,70.7,36.6L70.7,36.6z"
    ></path>
  </g>
  <g *ngIf="type === 'popupActive'">
    <path
      d="M83.7,35h-2.8c-0.6,0-1,0.5-1,1v2.8c0,0.6,0.5,1,1,1h2.8c0.6,0,1-0.5,1-1V36
    C84.8,35.4,84.3,35,83.7,35z M84.2,38.8c0,0.3-0.2,0.5-0.5,0.5h-2.8c-0.3,0-0.5-0.2-0.5-0.5V36c0-0.3,0.2-0.5,0.5-0.5h2.8
    c0.3,0,0.5,0.2,0.5,0.5V38.8z"
    ></path>
    <path
      d="M70.7,37.8c0.5,0,0.9-0.4,0.9-0.9S71.2,36,70.7,36s-0.9,0.4-0.9,0.9
    C69.8,37.4,70.2,37.8,70.7,37.8z M70.7,36.6c0.2,0,0.3,0.1,0.3,0.3s-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3l0,0
    C70.3,36.7,70.5,36.6,70.7,36.6L70.7,36.6z"
    ></path>
    <path
      d="M107.9,25.6l-15.8-3.7c-0.6-0.1-1.2,0-1.7,0.4c-0.5,0.4-0.7,0.9-0.7,1.5V29c0,1,0.9,1.9,1.9,1.9l15.8,0.2
    c0,0,0,0,0,0c0.5,0,1-0.2,1.4-0.5c0.4-0.4,0.6-0.8,0.6-1.4v-1.7C109.4,26.5,108.8,25.8,107.9,25.6z M108.9,29.1
    c0,0.4-0.1,0.7-0.4,1c-0.3,0.3-0.6,0.4-1,0.4l-15.8-0.2c-0.8,0-1.4-0.6-1.4-1.4v-5.3c0-0.4,0.2-0.8,0.5-1.1
    c0.2-0.2,0.5-0.3,0.9-0.3c0.1,0,0.2,0,0.3,0l15.8,3.7c0.6,0.1,1.1,0.7,1.1,1.3V29.1z"
    ></path>
    <path
      d="M68.9,21.4H57.5c-1.1,0-1.9,0.9-1.9,1.9v5.4c0,1,0.9,1.9,1.9,1.9h11.4c1.1,0,1.9-0.9,1.9-1.9v-5.4
    C70.8,22.2,70,21.4,68.9,21.4z M70.3,28.7c0,0.7-0.6,1.4-1.4,1.4H57.5c-0.8,0-1.4-0.6-1.4-1.4v-5.4c0-0.7,0.6-1.4,1.4-1.4h11.4
    c0.8,0,1.4,0.6,1.4,1.4V28.7z"
    ></path>
    <path
      d="M84,21.4h-1.3c-1.1,0-1.9,0.9-1.9,1.9v5.6c0,1,0.9,1.9,1.9,1.9H84c1.1,0,1.9-0.9,1.9-1.9v-5.6
    C86,22.2,85.1,21.4,84,21.4z M85.4,28.9c0,0.7-0.6,1.4-1.4,1.4h-1.3c-0.8,0-1.4-0.6-1.4-1.4v-5.6c0-0.7,0.6-1.4,1.4-1.4H84
    c0.8,0,1.4,0.6,1.4,1.4V28.9z"
    ></path>
    <path
      d="M52.7,22.2c-0.5-0.4-1.1-0.5-1.7-0.4l-15.8,3.7c-0.9,0.2-1.5,1-1.5,1.8v1.7c0,0.5,0.2,1,0.6,1.4
    c0.4,0.4,0.8,0.5,1.4,0.5c0,0,0,0,0,0l15.8-0.2c1.1,0,1.9-0.9,1.9-1.9v-5.3C53.4,23.1,53.1,22.6,52.7,22.2z M52.8,29
    c0,0.7-0.6,1.3-1.4,1.4l-15.8,0.2c-0.4,0-0.7-0.1-1-0.4c-0.3-0.3-0.4-0.6-0.4-1v-1.7c0-0.6,0.4-1.2,1.1-1.3l15.8-3.7
    c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0.1,0.9,0.3c0.3,0.3,0.5,0.6,0.5,1.1V29z"
    ></path>
    <path
      d="M31,24.9C31,25,31,25,31,24.9l1.2,6.9c0,1,0.9,1.9,1.9,1.9h15.1c-0.3,0.4-0.4,0.9-0.5,1.4
    c-0.2-0.2-0.5-0.3-0.8-0.3h-0.6c-0.6,0-1.1,0.5-1.1,1.1v6c0,0.6,0.5,1.1,1.1,1.1H48c0.6,0,1.1-0.5,1.1-1.1v-0.7h2.7
    c0.3,0.2,0.6,0.4,1,0.5L51.1,47c0,0.1,0,0.3,0.2,0.3c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.3-0.2l1.7-5.5h9.1c0.4,0,0.9-0.1,1.3-0.4
    c-0.4,0.7-0.6,1.4-0.6,2.2c0,2.4,2,4.3,4.4,4.3c2.4,0,4.4-1.9,4.4-4.3c0-0.7-0.2-1.4-0.5-2c0.2,0.1,0.5,0.2,0.8,0.2h16.4
    c0,0,0.1,0,0.1,0h4.1l5.3,5.6c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2-0.1c0.1-0.1,0.1-0.3,0-0.4L95.9,44l2.4-2.3h8v2.7
    c-0.1,0-0.1,0-0.2,0c-0.9,0-1.7,0.7-1.7,1.6s0.7,1.6,1.7,1.6s1.7-0.7,1.7-1.6c0-0.3-0.1-0.6-0.2-0.9v-3.4h0.7
    c0.5,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8h-0.7v-3.2c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6V40h-2.8v-4.2c0-0.6-0.5-1.1-1.1-1.1
    h-1.8c-0.6,0-1.1,0.5-1.1,1.1V40h-0.8v-2.8c0-0.5-0.4-1-0.9-1.1l-5.4-0.9v-0.1c0-0.6-0.2-1.1-0.5-1.5h17.2c1.1,0,1.9-0.8,1.9-1.9
    l1.4-8.1l0,0c0-0.9-0.7-1.8-1.7-1.9L92,19.5c0,0,0-0.1,0.1-0.1c0.3-0.5,0.3-1.1,0.1-1.6l-0.4-0.7c-0.3-0.5-0.9-0.9-1.5-0.9H50.8
    c-0.6,0-1.2,0.3-1.5,0.8L49,17.8c-0.3,0.5-0.3,1.1,0,1.6c0.1,0.1,0.1,0.2,0.2,0.3l-16.7,2.1c-1,0.1-1.7,0.9-1.7,1.9v0L31,24.9
    C31,24.9,31,24.9,31,24.9z M106.1,46.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4
    C106.5,46.2,106.3,46.4,106.1,46.4z M100,35.9c0-0.3,0.2-0.5,0.6-0.5h1.8c0.3,0,0.6,0.2,0.6,0.5V40H100V35.9z M78.6,32.6h-5.8V22.5
    c0-0.3,0.2-0.5,0.6-0.5h4.7c0.3,0,0.6,0.2,0.6,0.5V32.6z M72.9,40v-5.8h5.8V40L72.9,40z M48.6,41.8c0,0.3-0.2,0.5-0.6,0.5h-0.6
    c-0.3,0-0.6-0.2-0.6-0.5v-6c0-0.3,0.2-0.5,0.6-0.5H48c0.3,0,0.6,0.2,0.6,0.5V41.8z M49.1,38.1c0.1,0.2,0.2,0.3,0.3,0.5l1.8,2h-2.2
    V38.1z M67.6,46.2c-1.5,0-2.8-1.2-2.8-2.7c0-1.5,1.2-2.7,2.8-2.7c1.5,0,2.8,1.2,2.8,2.7C70.3,45,69.1,46.2,67.6,46.2z M72.2,40
    c-0.5-0.7-1.5-2.2-4.8-2.2c-1.1,0-3.2,0.5-4.2,1.9C63,39.9,62.7,40,62.5,40h-9.1c-0.2,0-0.4-0.1-0.6-0.3l-2.1-2.3
    c-0.2-0.2-0.3-0.5-0.3-0.7l0-1.5c0-0.5,0.4-1,0.8-1h21V40L72.2,40L72.2,40z M79.2,40v-5.8h10.7c0.5,0,0.8,0.4,0.8,1v3.8
    c0,0.5-0.4,1-0.8,1h-4.1L79.2,40z M95.5,43.6l-1.8-1.9h3.8L95.5,43.6z M97.7,36.7c0.3,0,0.5,0.3,0.5,0.5V40h-6
    c0.1-0.3,0.2-0.6,0.2-1v-3.2L97.7,36.7z M110.4,31.8L110.4,31.8c0,0.8-0.6,1.4-1.4,1.4H91.4c-0.4-0.3-0.9-0.5-1.5-0.5H79.2V22.5
    c0-0.6-0.5-1.1-1.1-1.1h-4.7c-0.6,0-1.1,0.5-1.1,1.1v10.2h-21c-0.6,0-1.1,0.2-1.5,0.5H34.1c-0.8,0-1.4-0.6-1.4-1.4v0l-1.1-6.6
    c9.3-0.7,17.5-4,19.6-5h39.4c0.3,0,0.6-0.1,0.8-0.2c0.8,0.4,9.8,4.4,20.1,5.2L110.4,31.8z M111.8,23.6l-0.2,1
    c-8-0.6-15.1-3.1-18.3-4.4l17.3,2.1C111.3,22.4,111.8,23,111.8,23.6z M50.8,17.9h39.4l0.4,0.7H50.4L50.8,17.9z M32.6,22.3L50,20.1
    c0,0,0,0,0,0c-3.1,1.3-10.3,3.9-18.5,4.5l-0.2-1C31.4,23,31.9,22.4,32.6,22.3z"
    ></path>
  </g>
</svg>
